import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./CSS/energy.css";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_energy_tags,
  set_external_trend_info,
  set_tag_values,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let state_2 = [
  {
    KOMPANZASYON: [
      { text: "Tüketim", tagId: "557", class: "kompanzasyonClass" },
      { text: "Toplam Aktif Güç", tagId: "552", class: "kompanzasyonClass" },
      { text: "Toplam Reaktif Güç", tagId: "553", class: "kompanzasyonClass" },
      {
        text: "Toplam Görünür Güç",
        tagId: "554",
        class: "kompanzasyonClass",
      },
      {
        text: "İndüktif Reaktif Enerji",
        tagId: "555",
        class: "kompanzasyonClass",
      },
      {
        text: "Kapasitif Reaktif Enerji",
        tagId: "556",
        class: "kompanzasyonClass",
      },
      { text: "L1 Gerilim", tagId: "543", class: "kompanzasyonClass" },
      { text: "L2 Gerilim", tagId: "550", class: "kompanzasyonClass" },
      { text: "L3 Gerilim", tagId: "551", class: "kompanzasyonClass" },
      { text: "L1 Akım", tagId: "547", class: "kompanzasyonClass" },
      { text: "L2 Akım", tagId: "548", class: "kompanzasyonClass" },
      { text: "L3 Akım", tagId: "549", class: "kompanzasyonClass" },
      { text: "Toplam Cosfi", tagId: "544", class: "kompanzasyonClass" },
      { text: "R Fazı Cosfi", tagId: "545", class: "kompanzasyonClass" },
      { text: "T Fazı Cosfi", tagId: "546", class: "kompanzasyonClass" },
      { text: "S Fazı Cosfi", tagId: "558", class: "kompanzasyonClass" },
    ],
  },
  {
    "ÇATI VRF BESLEME": [
      { text: "Tüketim", tagId: "185" },
      { text: "Güç", tagId: "180" },
      { text: "L1 Gerilim", tagId: "165" },
      { text: "L2 Gerilim", tagId: "173" },
      { text: "L3 Gerilim", tagId: "174" },
      { text: "L1 Akım", tagId: "175" },
      { text: "L2 Akım", tagId: "176" },
      { text: "L3 Akım", tagId: "177" },
      { text: "Güç Faktörü", tagId: "179" },
      { text: "Reaktif Güç ", tagId: "181" },
      { text: "Frekans", tagId: "183" },
    ],
  },
  {
    "MERDİVEN VE KAT AYDINLATMA": [
      { text: "Tüketim", tagId: "206" },
      { text: "Güç", tagId: "201" },
      { text: "L1 Gerilim", tagId: "186" },
      { text: "L2 Gerilim", tagId: "194" },
      { text: "L3 Gerilim", tagId: "195" },
      { text: "L1 Akım", tagId: "196" },
      { text: "L2 Akım", tagId: "197" },
      { text: "L3 Akım", tagId: "198" },
      { text: "Güç Faktörü", tagId: "200" },
      { text: "Reaktif Güç ", tagId: "202" },
      { text: "Frekans", tagId: "204" },
    ],
  },
  {
    "OTO YIKAMA": [
      { text: "Tüketim", tagId: "227" },
      { text: "Güç", tagId: "222" },
      { text: "L1 Gerilim", tagId: "207" },
      { text: "L2 Gerilim", tagId: "215" },
      { text: "L3 Gerilim", tagId: "216" },
      { text: "L1 Akım", tagId: "217" },
      { text: "L2 Akım", tagId: "218" },
      { text: "L3 Akım", tagId: "219" },
      { text: "Güç Faktörü", tagId: "221" },
      { text: "Reaktif Güç ", tagId: "223" },
      { text: "Frekans", tagId: "225" },
    ],
  },

  {
    "ASANSÖR 1": [
      { text: "Tüketim", tagId: "311" },
      { text: "Güç", tagId: "306" },
      { text: "L1 Gerilim", tagId: "291" },
      { text: "L2 Gerilim", tagId: "299" },
      { text: "L3 Gerilim", tagId: "300" },
      { text: "L1 Akım", tagId: "301" },
      { text: "L2 Akım", tagId: "302" },
      { text: "L3 Akım", tagId: "303" },
      { text: "Güç Faktörü", tagId: "305" },
      { text: "Reaktif Güç ", tagId: "307" },
      { text: "Frekans", tagId: "309" },
    ],
  },
  {
    "ASANSÖR 2": [
      { text: "Tüketim", tagId: "269" },
      { text: "Güç", tagId: "264" },
      { text: "L1 Gerilim", tagId: "249" },
      { text: "L2 Gerilim", tagId: "257" },
      { text: "L3 Gerilim", tagId: "258" },
      { text: "L1 Akım", tagId: "259" },
      { text: "L2 Akım", tagId: "260" },
      { text: "L3 Akım", tagId: "261" },
      { text: "Güç Faktörü", tagId: "263" },
      { text: "Reaktif Güç ", tagId: "265" },
      { text: "Frekans", tagId: "267" },
    ],
  },
  {
    "ASANSÖR 3": [
      { text: "Tüketim", tagId: "290" },
      { text: "Güç", tagId: "285" },
      { text: "L1 Gerilim", tagId: "270" },
      { text: "L2 Gerilim", tagId: "278" },
      { text: "L3 Gerilim", tagId: "279" },
      { text: "L1 Akım", tagId: "280" },
      { text: "L2 Akım", tagId: "281" },
      { text: "L3 Akım", tagId: "282" },
      { text: "Güç Faktörü", tagId: "284" },
      { text: "Reaktif Güç ", tagId: "286" },
      { text: "Frekans", tagId: "288" },
    ],
  },
];
const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  state_2.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/energy") {
        try {
          const request = await fetch(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              method: "POST",
              body: JSON.stringify(obj2__),
            }
          );
          const response = await request.json();

          Store.dispatch(set_energy_tags(response));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 3500);
};

setTimeout(() => {
  inital_func();
}, 1000);

const Energy = (props) => {
  const [tag_values, Set_tag_values] = useState([]);

  const [state, SetState] = useState(state_2);

  const history = useHistory();

  const maxValueByType = {
    "L1 Gerilim": 240,
    "L2 Gerilim": 240,
    "L3 Gerilim": 240,
    "L1 Akım": 650,
    "L2 Akım": 650,
    "L3 Akım": 650,
  };
  const minValueByType = {
    "L1 Gerilim": 210,
    "L2 Gerilim": 210,
    "L3 Gerilim": 210,
  };

  useEffect(() => {
    console.log(props.tag_values);

    Set_tag_values(props.tag_values);
  }, [props.tag_values]);

  useEffect(() => {
    const componentDidMount = () => {
      var obj__ = [];
      var obj2__ = [];

      state_2.forEach((item) => {
        Object.entries(item).forEach((a) => {
          obj__.push(a[1]);
        });
      });

      obj__.forEach((item2) => {
        item2.forEach((item3) => {
          obj2__.push({ tagId: item3.tagId });
        });
      });

      var newdata = [];

      obj2__.forEach((item2) => {
        props.tag_values.forEach((item) => {
          if (item.tagId === item2.tagId) {
            newdata.push({
              tagId: item.tagId,
              tagValue: item.tagValue,
            });
          }
        });
      });

      console.log(newdata);

      Set_tag_values(newdata);
    };

    componentDidMount();
  }, []);

  const getBackgroundStyle = (type, valueString) => {
    const numericValue = parseFloat(valueString).toFixed(2);
    console.log("value : " + numericValue);

    if (!maxValueByType.hasOwnProperty(type)) {
      return { background: "white" };
    }

    const maxValue = maxValueByType[type];
    const minValue = minValueByType[type] || 0;
    const adjustedValue = Math.max(numericValue - minValue, 0);
    const adjustedMaxValue = maxValue - minValue;
    const ratio = Math.min(Math.max(adjustedValue / adjustedMaxValue, 0), 1);

    if (type.includes("Çalışma Durumu")) {
      return {
        background: `linear-gradient(to right, rgb(76, 187, 23) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    } else if (type.includes("Arıza Durumu") || type.includes("Alarm")) {
      return {
        background: `linear-gradient(to right, 	rgb(255, 36, 0) ${
          ratio * 100
        }%, white ${ratio * 100}%)`,
      };
    }

    return {
      background: `linear-gradient(to right, rgb(237, 188, 69) ${
        ratio * 100
      }%, white ${ratio * 100}%)`,
    };
  };

  // setInterval(() => {

  //     console.log(control);

  //     if (props.tag_ids && control === true && window.location.pathname === "/energy") {
  //         const fetch_tag_values = async () => {
  //             try {
  //                 const request = await fetch(
  //                     "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
  //                     {
  //                         headers: {
  //                             "Content-Type": "application/json",
  //                             accept: "application/json",
  //                         },
  //                         method: "POST",
  //                         body: JSON.stringify(obj2__),
  //                     }
  //                 );
  //                 const response = await request.json();

  //                 console.log(response);

  //                 Set_tag_values(response);
  //             } catch (err) {
  //                 console.log(err);
  //             } finally {
  //                 Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false))
  //             }
  //         }

  //         fetch_tag_values()
  //     }

  // }, 10000)

  const loadingStyle = {
    background: "linear-gradient(to right, #f0f0f0 50%, white 50%)",
  };

  function splitValueAndUnit(value) {
    const valueWithDot = value.replace(",", ".");
    const matches = valueWithDot.match(/([0-9.]+)\s*(.*)/);
    if (matches) {
      return { number: parseFloat(matches[1]), unit: matches[2] };
    }
    return { number: parseFloat(valueWithDot), unit: "" };
  }
  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };
  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  return (
    <div className="energy1-page">
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>

          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <section className="section_energy">
        <Link to="/">
          <Button
            style={{
              position: "absolute",
              color: "black",
              top: "12%",
              left: "18%",
              zIndex: 9999999,
              borderRadius: "15px",
              backgroundColor: "#fff",
              border: "3px solid rgba(238, 200, 108, 0.99)",
              fontWeight: 600,
            }}
            className=" movebuttons-energy"
            variant="contained"
          >
            Ana Ekran
          </Button>
        </Link>
        <div className="top">
          <div>ENERJİ ANALİZÖRLERİ</div>
        </div>
        <div className="buttonarea-energy">
          <Link className="buttons" to="/energy3">
            Geri
          </Link>
          <Link className="buttons" to="/energy2">
            İleri
          </Link>
        </div>
        <div className="bottom">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              title.push(a[0]);
              obj_.push(a[1]);
            });

            console.log(obj_);
            // var değer = tag_values
            //     .filter(
            //         (x) => String(x.tagId) === String(item.elementDetails.tagId)
            //     )
            //     .map((a) => a.tagValue);
            return (
              <div className="rows">
                <div className="left">
                  <div></div>
                  <div className="lefttitle">{title[0]}</div>
                </div>
                <div className="right">
                  <div className="right_top">
                    {obj_[0].map((x, index) => {
                      console.log(x);
                      function sondanIlkBosluktanSonrakiKisim(metin) {
                        if (metin !== undefined) {

                        // Metni ters çevir
                        var tersMetin = metin.split("").reverse().join("");

                        // İlk boşluğun index'ini bul
                        var ilkBoslukIndex = tersMetin.indexOf(" ");

                        // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                        var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                        // İlk boşluğun index'inden sonraki kısmı al
                        var sonrakiKisim = metin.substring(orijinalIndex + 1);

                        return sonrakiKisim;
                        }
                      }
                      var değerler = props.energy_tags
                        .filter((a) => String(a.tagId) === String(x.tagId))
                        .map((b) => b.tagValue);
                      var değerler_eleman = değerler[0];
                      console.log(değerler);
                      var unit =
                        sondanIlkBosluktanSonrakiKisim(değerler_eleman);
                      console.log(unit);
                      return (
                        <div className={x.class + " righttop"}>
                          {x.text + ` (${unit})`}
                        </div>
                      );
                    })}
                  </div>
                  <div className="right_bottom">
                    {obj_[0].map((x, index) => {
                      var değerler = props.energy_tags
                        .filter((a) => String(a.tagId) === String(x.tagId))
                        .map((b) => b.tagValue);
                      var değerler_eleman = değerler[0];

                      function sondanIlkBoslukIndexiniBul(metin) {
                        if (metin !== undefined) {

                        // Metni ters çevir
                        var tersMetin = metin.split("").reverse().join("");

                        // İlk boşluğun index'ini bul
                        var ilkBoslukIndex = tersMetin.indexOf(" ");

                        // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                        var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                        return orijinalIndex;
                        }
                      }

                      function metniIndexeKadarAl(metin, index) {
                        if(metin!==undefined){
                        // substring kullanarak
                        var metinSubstring = metin.substring(0, index);

                        // veya slice kullanarak

                        metinSubstring = String(metinSubstring);
                        metinSubstring = metinSubstring.replaceAll(",", ".");

                        metinSubstring = Number(metinSubstring).toFixed(2);

                        return metinSubstring;
                        }
                      }
                      function sondanIlkBosluktanSonrakiKisim(metin) {
                        // Metni ters çevir
                        var tersMetin = metin.split("").reverse().join("");

                        // İlk boşluğun index'ini bul
                        var ilkBoslukIndex = tersMetin.indexOf(" ");

                        // İlk boşluğun index'ini ters çevrilen metin üzerinden orijinal metin üzerine dönüştür
                        var orijinalIndex = metin.length - 1 - ilkBoslukIndex;

                        // İlk boşluğun index'inden sonraki kısmı al
                        var sonrakiKisim = metin.substring(orijinalIndex + 1);

                        return sonrakiKisim;
                      }
                      var last_değer = metniIndexeKadarAl(
                        değerler_eleman,
                        sondanIlkBoslukIndexiniBul(değerler_eleman)
                      );
                      const matchingTag = props.tag_list.find(tag => tag.tagId === x.tagId);

                          // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                          const decimalPlaces = matchingTag && matchingTag.tagDecimal !== null
                            ? Number(matchingTag.tagDecimal)
                            : 2;



                          last_değer = decimalPlaces !== 0 ? Number(last_değer).toFixed(decimalPlaces) : Number(last_değer).toFixed(2)
                      if (x.text.includes("Çalışma Durumu")) {
                        console.log(last_değer, typeof last_değer);
                        if (String(last_değer) === "1.00 ") {
                          console.log(last_değer, "qwer");
                          last_değer = "ON";
                        } else {
                          last_değer = "OFF";
                        }
                      } else if (
                        x.text.includes("Arıza Durumu") ||
                        x.text.includes("Alarm")
                      ) {
                        if (String(last_değer) === "1.00 ") {
                          last_değer = "ALARM";
                        } else {
                          last_değer = "NORMAL";
                        }
                      } else {
                        function formatNumber(number) {
                          // Sayıyı stringe çevirme ve ondalık kısmı ve tam kısmı ayırma
                          const parts = number.toString().split(".");
                          // Tam kısmın her 3 basamağında bir virgül eklemek için regex kullanma
                          parts[0] = parts[0].replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            "."
                          );
                          // Virgülden sonraki kısmı alıp, sonuna iki haneli bir ondalık eklemek
                          if (parts[1]) {
                            parts[1] = parts[1].padEnd(2, "0");
                          } else {
                            parts.push("00");
                          }
                          // Parçaları birleştirip sonucu döndürme
                          return parts.join(",");
                        }
                        last_değer = formatNumber(last_değer);
                      }

                      return değerler.length > 0 ? (
                        değerler.map((değer) => (
                          <div
                            onContextMenu={(e) => {
                              e.preventDefault();
                              const { clientX, clientY } = e;
                              console.log(clientX, clientY);
                              var tagName = props.tag_list
                                .filter((b) => b.tagId === x.tagId)
                                .map((c) => c.tagName)[0];

                              document.querySelector(
                                ".show_tagName"
                              ).innerHTML = tagName;

                              document
                                .querySelector(".show_external_trend")
                                .classList.toggle("show_external_trend_active");
                              document.querySelector(".show_tagId").innerHTML =
                                x.tagId;
                              var popup = document.querySelector(
                                ".show_external_trend"
                              );
                              const popupRect = popup.getBoundingClientRect();
                              const viewportWidth = window.innerWidth;
                              const viewportHeight = window.innerHeight;

                              // Calculate the new positions
                              let newX = clientX;
                              let newY = clientY;

                              // Adjust if the popup would overflow the right edge of the viewport
                              if (newX + popupRect.width > viewportWidth) {
                                newX = viewportWidth - popupRect.width;
                              }

                              // Adjust if the popup would overflow the bottom edge of the viewport
                              if (newY + popupRect.height > viewportHeight) {
                                newY = viewportHeight - popupRect.height;
                              }

                              // Adjust if the popup would overflow the left edge of the viewport
                              if (newX < 0) {
                                newX = 0;
                              }

                              // Adjust if the popup would overflow the top edge of the viewport
                              if (newY < 0) {
                                newY = 0;
                              }

                              // Set the position of the popup
                              popup.style.left = `${newX}px`;
                              popup.style.top = `${newY}px`;
                            }}
                            style={getBackgroundStyle(x.text, değer)}
                          >
                            {last_değer}
                          </div>
                        ))
                      ) : (
                        <div
                          className={x.class + " rightbottom"}
                          style={loadingStyle}
                        >
                          {"Veri Yükleniyor"}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

const MapStateToProps = (state) => {
  return {
    pages_: state.project_reducer.pages,
    tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    user_id: state.auth_reducer.user_id,
    company_id: state.project_reducer.company_id,
    tag_list: state.project_reducer.tag_list,
    white_space_: state.project_reducer.white_space_items,
    fetch_tag_value_control: state.project_reducer.fetch_tag_value_control,
    energy_tags: state.project_reducer.energy_tags1,
  };
};
export default connect(MapStateToProps)(Energy);
